import React, { useEffect } from 'react'
import { actions as formActions, getModel } from 'react-redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'



import { SearchContainer } from './SearchContainer'

import { usePrevious, useQuery } from '../../util/hooks'
import {
  extractFilters,
  queryStringDiffRequiresReload,
  setFormFromResponse
} from '../../actions/search'



const SearchQueryHandlerComponent = props => {
  const dispatch = useDispatch()
  const location = useLocation()
  const searchFilterFormName = 'search.searchFilterForm'
  const resultRows = useSelector(state => state.search.resultHolderReducer)
  const searchFilterForm = useSelector(state => state.search.searchFilterForm)
  const searchFilterModel = useSelector(state => {
    const model = getModel(state, searchFilterFormName)

    return model
  })
  const extractAndSearch = props => {

    const newModel = dispatch(extractFilters(searchFilterFormName, location))

    dispatch(props.loadFunction(newModel)).then(f => {

      dispatch(setFormFromResponse(f, searchFilterFormName))
    })
    // console.log("SETTING", newModel)
    props.setFilterModel(newModel)
  }
  const searchLocation = useQuery()
  const prevSearchLocation = usePrevious(searchLocation)
  const requireReload =
    prevSearchLocation == null
      ? false
      : queryStringDiffRequiresReload(searchLocation, prevSearchLocation)
  const signedIn = useSelector(state => !!state.authenticationState.userProfile)
  const wasSignedIn = usePrevious(signedIn)
  const authStateChanged = wasSignedIn == null ? false : signedIn != wasSignedIn
  //console.log('QSTRING', requireReload, searchLocation, prevSearchLocation)

  //Clear the form on the initial load
  useEffect(() => {
    dispatch(formActions.reset(searchFilterFormName))
  }, [])

  useEffect(() => {

    extractAndSearch(props)
  }, [authStateChanged, requireReload])

  return (
    <SearchContainer
      searchRequest={props.searchRequest}
      resultRows={resultRows}
      searchFilterModel={searchFilterModel}
      loadMoreRows={props.loadMoreFunction}
      searchFilterFormName={searchFilterFormName}
      searchFilterForm={searchFilterForm}
    />
  )
}

SearchQueryHandlerComponent.propTypes = {
  loadFunction: PropTypes.func,
  setFilterModel: PropTypes.func,
  searchRequest: PropTypes.object,
  loadMoreFunction: PropTypes.func
}

export default SearchQueryHandlerComponent
